import React, { Component } from "react";
import UserList from "./UserList";
import GradeList from "./GradeList";
import axiosInstance from "../../server/axios";
import { useState } from "react";
import { Button } from "@mui/material";

const userid = localStorage.getItem('happycallname');

const AdminMain = () => {
  const [contents, setContents] = useState([]);
  const [menu, setmenu] = useState('');
  const [titleList, setTitleList] = useState(['USERLIST','USER GRADE','GET FILE LIST','UpLoad sales file','MENU 4','MENU 5']);
  const [title, setTitle] = useState('Admin Title');

  const getContents = (data) => {
    setContents(data);
  }
  const handleClickButton = (number) => {
    setTitle(titleList[number]);
    if(number === 0){getUserList()}
    if(number === 1){getGrade()}
    if(number === 2){getFilelist()}
  }
  const getUserList = async () => {
    const Userlist = await axiosInstance.get('/users/all');
    setmenu('userlist');
    setContents({users:Userlist.data.userlist,grade:Userlist.data.gradelist})
  }
  const getGrade = async () => {
    const gradelist = await axiosInstance.get(`/admin/grade/all?userid=${userid}`);
    setContents({grade:gradelist.data.gradelist,users:gradelist.data.userlist })
    setmenu('gradelist');
  }
  const getFilelist = async () => {
    const gradelist = await axiosInstance.get(`/admin/filelist/${userid}`);
    //console.log(gradelist);
    //setContents({grade:gradelist.data.gradelist,users:gradelist.data.userlist })
    setmenu('getfilelist');
  }

  return (
    <div className="admin_container">
      <div className="admin_menu">
        {titleList.map((val,i)=>
        <Button key={val} variant="contained" color="primary" size="big" onClick={()=>handleClickButton(i)}>{val}</Button>
        )}
      </div>
      <div className="admin_contents">
        <div className="admin_title">{title}</div>
        <div className="admin_view">
          {
          menu === 'userlist'?
          <div><UserList data={contents} update={getContents}></UserList></div>
          :
          menu === 'gradelist'?
          <div><GradeList data={contents} update={getContents}></GradeList></div>
          :
          menu === 'gradelist'?
          <div>getfilelist</div>
          :
          <>select sub menu</>
          }
        </div>
      </div>
    </div>
  )
}
export default AdminMain;